export default {
    name:'my',
    install(Vue) {
        Vue.component('MyDialog', () => import('./my-dialog.vue')); // 弹框
        Vue.component('MyDrawer', () => import('./my-drawer.vue')); // 抽屉

        Vue.component('MyCopy', () => import('./my-copy.vue'));

        Vue.component('MyPageSelect', () => import("./my-page-select.vue")); // 分页选择
        Vue.component('MyTags', () => import('./my-tags.vue'));  // 多个标签
        Vue.component('MyArea', () => import('./my-area.vue')); // 地区选择，省；市；区/县
        Vue.component('MyUpimg', () => import('./my-upimg.vue')); //  图片上传
        Vue.component('MyEdit', () => import('./my-edit.vue'));  // 在线编辑器
        Vue.component('MySplitLine', () =>import('./my-split-line.vue')); // 分割线

        Vue.component('MyRandom', () => import('./my-random.vue')); // 产生随机数
        Vue.component('MyChart', () =>import('./my-chart.vue')); // 使用百度的图表功能
        Vue.component('MyMap', () => import('./my-map.vue')); // 使用百度的地图功能

        Vue.component('MyMobile', () => import('./my-mobile.vue')); // 只能输入手机号码
        Vue.component('MyPwd', () => import('./my-pwd.vue')); // 密码设置

        Vue.component('MyImg', () => import('./my-img.vue')); // 自定义图片展示
        Vue.component('MyImgMult', () => import('./my-img-mult.vue')); // 点击上传多图
        Vue.component('MyImgSelect', () => import('./my-img-select.vue')); // 点击选择图片

        Vue.component('MyNumber', () => import('./my-number.vue' )); // 数字输入框

        Vue.component('MyAttr', () => import('./my-attr.vue' )); // 数字输入框
        Vue.component('MyAttrSet', () => import('./my-attr-set.vue' )); // 属性配置
        Vue.component('MyList', () => import('./my-list.vue' )); // 列表
        Vue.component('MyDate', () => import('./my-date.vue'));

    }
}